module.exports = __webpack_public_path__ + "question-cp.01c9f80385c304f3b76a.png";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/assets/images/question-cp.png
// module id = ../../../../../src/assets/images/question-cp.png
// module chunks = main